(() => {
  const name = 'concern-navigation-aws9rtvzweml3dvd1baigenblock570a2fbmwdap8';
  if (customElements.get(name)) return;
  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const cards = [...this.querySelectorAll('[data-card-index]:not([hidden])')];
      const detail = this.querySelector('[id^="concern-detail-"]');
      if (!detail || !cards.length) return;
      let selected = null;
      const measure = () => {
        if (!selected) return;
        const probe = detail.cloneNode(false);
        probe.removeAttribute('id');
        probe.removeAttribute('aria-live');
        probe.setAttribute('aria-hidden', 'true');
        probe.inert = true;
        probe.hidden = false;
        probe.style.cssText = 'position:absolute;top:0;left:0;visibility:hidden;pointer-events:none;margin:0;min-height:0;';
        probe.style.width = detail.getBoundingClientRect().width + 'px';
        this.appendChild(probe);
        let height = 0;
        cards.forEach(card => {
          const template = this.querySelector('[data-concern-template="' + card.dataset.cardIndex + '"]');
          if (!template) return;
          probe.replaceChildren(template.content.cloneNode(true));
          probe.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          height = Math.max(height, probe.getBoundingClientRect().height);
        });
        probe.remove();
        detail.style.minHeight = Math.ceil(height) + 'px';
      };
      const close = () => {
        selected = null;
        cards.forEach(card => {
          card.classList.remove('is-open');
          card.setAttribute('aria-expanded','false');
        });
        detail.hidden = true;
        detail.replaceChildren();
        detail.style.removeProperty('min-height');
      };
      cards.forEach(card => card.addEventListener('click', () => {
        if (selected === card) { close(); return; }
        const template = this.querySelector('[data-concern-template="' + card.dataset.cardIndex + '"]');
        if (!template) return;
        selected = card;
        cards.forEach(item => {
          item.classList.toggle('is-open', item === card);
          item.setAttribute('aria-expanded', String(item === card));
        });
        // Keep the same panel open and keep focus on the user's chosen card.
        detail.replaceChildren(template.content.cloneNode(true));
        detail.hidden = false;
        measure();
      }, {signal}));
      let lastWidth = 0;
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.getBoundingClientRect().width;
        if (width !== lastWidth) { lastWidth = width; measure(); }
      });
      this.resizeObserver.observe(this);
      document.fonts?.ready.then(() => { if (!signal.aborted) measure(); });
      close();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
})();
